import { Button, Spinner } from '@chakra-ui/react';
import { PDFDownloadLink } from '@react-pdf/renderer';

import OrderDetailsPdfTemplate from 'components/pdfs/OrderDetailPDFTemplate';
import { useEffect, useState } from 'react';
import { MdUpload } from 'react-icons/md';
import { Order } from 'types/order';
import { SKU } from 'types/sku';

type OrderDetailsPDFGeneratorProps = {
  order: Order;
  skuData: SKU[];
};

const OrderDetailsPDFGenerator = ({
  order,
  skuData,
}: OrderDetailsPDFGeneratorProps) => {
  const [blobData, setBlobData] = useState<Blob | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [pdfReady, setPdfReady] = useState<boolean>(false);
  const groupName =
    order?.group?.companyName || order?.portal?.name || order?.site?.name;
  const fileName = `Order Details - ${groupName} - ${order?.orderNumber}.pdf`;

  const handleDownload = (blob: Blob | null, fileName: string) => {
    if (blob) {
      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }
  };

  // Effect to handle downloading the first PDF when ready
  useEffect(() => {
    if (loading && blobData) {
      handleDownload(blobData, fileName);
      setLoading(false);
    }
  }, [blobData, loading]);

  return (
    <>
      {loading && <Spinner />}
      {blobData && (
        <Button gap="10px" onClick={() => handleDownload(blobData, fileName)}>
          <MdUpload />
          Export PDF
        </Button>
      )}
      <PDFDownloadLink
        document={<OrderDetailsPdfTemplate data={order} skuData={skuData} />}
        fileName={fileName}>
        {({ blob, loading }: { blob: Blob | null; loading: boolean }) => {
          setLoading(true);
          if (blob && !blobData) {
            setBlobData(blob);
            setPdfReady(true);
          }
          setLoading(false);
          return null;
        }}
      </PDFDownloadLink>
    </>
  );
};

export default OrderDetailsPDFGenerator;
